<template lang="pug">
  .resource-view-wrapper(:class="'context-' + context")
    include DashboardBenefits.pug
</template>

<script>
import slug from "slug"
import _ from 'underscore'
import Api from "@/components/services/Api";
import Notification from "./Notification";
import Announcement from "./Announcement";
import DashboardCard from "./DashboardCard";
import BenefitsPackItem from "./../benefits/BenefitsPackItem"
import { mapState } from 'vuex';

export default {
  name: 'DashboardBenefits',
  components: {
    Notification,
    Announcement,
    DashboardCard,
    BenefitsPackItem,
  },
  computed: mapState([
    "context", "token",
  ]),
  data() {
    return {
      user: null,
      visible: false,
      announcements: [],
      notifications: [],
      completeness: null,
      progressColor: "red",
      plan: null,
      perms: [],
      groups: [
        "Perfil",
        "Marketing",
        "Recursos",
        "Descuentos",
      ],
    }
  },
  async created() {
    const _this = this;

    const meResponse = await Api.me(this.token)
    const meData = meResponse.data
    const plan = meData.plan
    let hasLopd = meData.lopd

    if (hasLopd) {
      this.user = meResponse.data;
      this.announcements = this.user.announcements
      this.notifications = this.user.notifications
      this.completeness = this.user.completeness
      this.visible = true;

      // Decide class wrapper
      if (_this.completeness < 50) {
        this.progressColor = "#b71c1c"
      } else if (this.completeness <= 75) {
        this.progressColor = "#fecc39"
      } else {
        this.progressColor = "#7ea4b3"
      }
    } else {
      this.$router.push({
        name: "Lopd",
      });
    }

    // Load permissions
    const permissionsResponse = await Api.getPermissions()
    const data = permissionsResponse.data

    const perms = data[plan]
    console.log({plan, perms}, "pep")
    this.perms = perms
  },
  methods: {
    inGroup(item, group) {
      if (!item.visible) return false
      const groupSlug = slug(group).toUpperCase()
      const splittedPerm = _.first(item.name.split("_"))
      return (groupSlug == splittedPerm)
    }
  },
  filters: {
    groupname: function(value) {
      const lowername = value.toLowerCase()
      switch (lowername) {
        case "registro":
          return "Credenciales Federativas dashboard"
        case "recursos":
          return "Recursos Profesionales"
        case "descuentos":
          return "Descuentos del Sector"
        case "marketing":
          return "Kit de Marketing"
        case "perfil":
          return "Perfil Profesional"
      }

      return value
    }
  }
}

</script>

<style scoped lang="scss">

@import "./../../variables";
@import "Dashboard";
@import "DashboardIndex";
@import "./../../styles/bars";
@import "./../benefits/Benefits";
@import "./../benefits/BenefitsPack";
@import "DashboardBenefits";

</style>



// WEBPACK FOOTER //
// src/components/dashboard/DashboardBenefits.vue